import { NgModule } from '@angular/core';
import {CommonModule} from '@angular/common';

import 'd3';
import 'nvd3';

import { MenuItems } from './menu-items/menu-items';
import { AccordionAnchorDirective, AccordionLinkDirective, AccordionDirective } from './accordion';
import { ToggleFullscreenDirective } from './fullscreen/toggle-fullscreen.directive';
import {CardRefreshDirective} from './card/card-refresh.directive';
import {CardToggleDirective} from './card/card-toggle.directive';
import { CardComponent } from './card/card.component';
import {NgbModule, NgbModalModule, NgbDatepickerModule, NgbTimepickerModule} from '@ng-bootstrap/ng-bootstrap';
import {ParentRemoveDirective} from './elements/parent-remove.directive';
import {SqueezeBoxModule} from 'squeezebox';
import {PaginationModule} from 'ngx-bootstrap';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {SpinnerComponent} from '../spinner/spinner.component';
import {ModalAnimationComponent} from './modal-animation/modal-animation.component';
import {ModalBasicComponent} from './modal-basic/modal-basic.component';
import {ScrollModule} from '../scroll/scroll.module';
import {ToastyModule} from 'ng2-toasty';
import {SimpleNotificationsModule} from 'angular2-notifications';
import {TagInputModule} from 'ngx-chips';
import {AnimatorModule} from 'css-animator';
import {DatepickerModule} from 'angular2-material-datepicker';
import {ColorPickerModule} from 'ngx-color-picker';
import {CurrencyMaskModule} from 'ng2-currency-mask';
import {Ng2MaskModule} from 'ng2-mask/build/ng2-mask.module';
import {SelectModule} from 'ng-select';
import {SelectOptionService} from './elements/select-option.service';
import {FormWizardModule} from 'angular2-wizard';
import {NgxDatatableModule} from '@swimlane/ngx-datatable';
import {QuillEditorModule} from 'ngx-quill-editor';
import {DataFilterPipe} from './elements/data-filter.pipe';
import {DataTableModule} from 'angular2-datatable';
import {FroalaEditorModule, FroalaViewModule} from 'angular-froala-wysiwyg';
import {FileUploadModule} from 'ng2-file-upload';
import {ScrollToModule} from '@nicky-lenaers/ngx-scroll-to';
import {AgmCoreModule} from '@agm/core';
import {Ng2GoogleChartsModule} from 'ng2-google-charts';
import {AngularEchartsModule} from 'ngx-echarts';
import {UiSwitchModule} from 'ng2-ui-switch/dist';
import {ChartModule} from 'angular2-chartjs';
import {KnobModule} from 'ng2-knob';
import {ChartistModule} from 'ng-chartist';
import {NvD3Module} from 'ng2-nvd3';

import {TodoService} from './todo/todo.service';
import {ClickOutsideModule} from 'ng-click-outside';
import { NavigationLaboratoireComponent } from './navigation-laboratoire/navigation-laboratoire.component';
import { RouterModule } from '@angular/router';
import { prescriptionRoutes } from '../laboratoire/prescription/prescription.routing';
import { CalendarModule } from 'angular-calendar';
import { CalendarHeaderComponent } from './calendar-utils/calendar-header.component';
import { CalendarUtilsComponent } from './calendar-utils/calendar-utils.component';
import { AjoutlangueComponent } from 'app/parametrage/matrimoniale/langue/ajoutlangue/ajoutlangue.component';
import { AjouterComponent } from 'app/parametrage/profession/ajouter/ajouter.component';
import { AjoutpaysComponent } from 'app/parametrage/matrimoniale/pays/ajoutpays/ajoutpays.component';
import { AjoutCorpsComponent } from 'app/parametrage/corps/ajout-corps/ajout-corps.component';
import { AjoutGradeComponent } from 'app/parametrage/grade/ajout-grade/ajout-grade.component';
import { AlertComponent } from 'app/consultation/alert/alert.component';
import { AjoutLienComponent } from 'app/parametrage/lien-parental/ajout-lien/ajout-lien.component';
import { ListeComorbiditeComponent } from 'app/comorbidite/comorbidites/liste-comorbidite/liste-comorbidite.component';
import { PickersortieDialyseComponent } from 'app/patients/pickersortie-dialyse/pickersortie-dialyse.component';
import { ExcelService } from 'app/core/excel.service';
import { InformationPatientComponent } from 'app/patients/information-patient/information-patient.component';
import { FormInformationPatientComponent } from 'app/patients/form-information-patient/form-information-patient.component';
import { ShowInformationComponent } from 'app/patients/show-information/show-information.component';
import { AlerteComponent } from 'app/admissions/alerte/alerte.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule.forRoot(),
    PaginationModule.forRoot(),
    SqueezeBoxModule,
    ScrollModule,
    ToastyModule.forRoot(),
    SimpleNotificationsModule.forRoot(),
    TagInputModule,
    UiSwitchModule,
    AnimatorModule,
    DatepickerModule,
    ColorPickerModule,
    SelectModule,
    Ng2MaskModule,
    CurrencyMaskModule,
    FormWizardModule,
    NgxDatatableModule,
    DataTableModule,
    QuillEditorModule,
    FroalaEditorModule.forRoot(),
    FroalaViewModule.forRoot(),
    FileUploadModule,
    ScrollToModule.forRoot(),
    AgmCoreModule.forRoot({
      apiKey: "AIzaSyCE0nvTeHBsiQIrbpMVTe489_O5mwyqofk"
    }),
    Ng2GoogleChartsModule,
    AngularEchartsModule,
    ChartModule,
    KnobModule,
    ChartistModule,
    NvD3Module,
    ClickOutsideModule,
    NgbDatepickerModule.forRoot(),
    NgbTimepickerModule.forRoot(),
    CalendarModule
  ],
  declarations: [
    AccordionAnchorDirective,
    AccordionLinkDirective,
    AccordionDirective,
    ToggleFullscreenDirective,
    CardRefreshDirective,
    CardToggleDirective,
    ParentRemoveDirective,
    CardComponent,
    SpinnerComponent,
    ModalAnimationComponent,
    ModalBasicComponent,
    DataFilterPipe,
    NavigationLaboratoireComponent,
    CalendarHeaderComponent,
    CalendarUtilsComponent,
    AjoutlangueComponent,
    AjouterComponent,
    AjoutpaysComponent,
    AjoutCorpsComponent,
    AjoutGradeComponent,
    AlertComponent,
    AjoutLienComponent,
    PickersortieDialyseComponent,
    ShowInformationComponent,
    FormInformationPatientComponent,
    AlerteComponent
  ],
  exports: [
    AccordionAnchorDirective,
    AccordionLinkDirective,
    AccordionDirective,
    ToggleFullscreenDirective,
    CardRefreshDirective,
    CardToggleDirective,
    ParentRemoveDirective,
    CardComponent,
    SpinnerComponent,
    SqueezeBoxModule,
    NgbModule,
    PaginationModule,
    FormsModule,
    ReactiveFormsModule,
    ModalBasicComponent,
    ModalAnimationComponent,
    ScrollModule,
    ToastyModule,
    SimpleNotificationsModule,
    TagInputModule,
    UiSwitchModule,
    AnimatorModule,
    DatepickerModule,
    ColorPickerModule,
    SelectModule,
    Ng2MaskModule,
    CurrencyMaskModule,
    FormWizardModule,
    NgxDatatableModule,
    DataTableModule,
    DataFilterPipe,
    QuillEditorModule,
    FroalaEditorModule,
    FroalaViewModule,
    FileUploadModule,
    ScrollToModule,
    AgmCoreModule,
    Ng2GoogleChartsModule,
    AngularEchartsModule,
    ChartModule,
    KnobModule,
    ChartistModule,
    NvD3Module,
    ClickOutsideModule,
    NavigationLaboratoireComponent,
    CalendarHeaderComponent,
    CalendarUtilsComponent,
    CalendarModule
  ],
  providers: [MenuItems, TodoService, SelectOptionService,
    ExcelService]
})
export class SharedModule {}



// WEBPACK FOOTER //
// /home/masdev/Documents/NEPHROSYSTEMLAST/nephrosystem-webapp/src/app/shared/shared.module.ts